export default __webpack_public_path__ + "static/media/2_0068.3a74e8fb.webp";